import React from 'react';
import { useIntl } from 'react-intl';
import each from 'lodash/each';
import keys from 'lodash/keys';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

import { getI18n } from "../../../utils/intl";
import MultiSelectMenu from '../MultiSelectMenu';

import styles from './styles';

const FilterByRange = (props) => {
  const {
    filterData, selectedItems = {}, maxAllowedEntities, updateSelectedItems, hideCount,
  } = props;

  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const getMenuData = () => {
    const menuData = [];
    each(filterData, (item, key) => {
      menuData.push({ labelKey: item.labelKey, rangeKey: item.rangeKey, value: key });
    });
    return menuData;
  }

  const handleOnSelect = (value, checked) => {
    if (checked) {
      selectedItems[value] = true;
    } else if (selectedItems[value]) {
      delete selectedItems[value];
    }
    updateSelectedItems(selectedItems);
  };

  const selectedEntities = keys(selectedItems).length;
  const remainingSlots =
    maxAllowedEntities - selectedEntities < 0
      ? maxAllowedEntities
      : maxAllowedEntities - selectedEntities;
  const menuData = getMenuData();

  const renderLabel = (item) =>
    (<div>
      <b>{intl.getI18nMessage(item.labelKey)}</b>
      <br />
      {intl.getI18nMessage(item.rangeKey)}
    </div>);

  return (
    <div className={classes.filterContainer}>
      <MultiSelectMenu
        data={menuData}
        renderLabel={renderLabel}
        selectedData={selectedItems}
        handleOnSelect={handleOnSelect}
      />
      {hideCount ? null : (
        <div className={classes.filterFooter}>
          <span className={classes.slotsDetail}>
            {remainingSlots}/{maxAllowedEntities} data slots remaining
          </span>
        </div>
      )}
    </div>
  );
}

FilterByRange.propTypes = {
  filterData: PropTypes.object,
  selectedItems: PropTypes.object,
  updateSelectedItems: PropTypes.func,
  maxAllowedEntities: PropTypes.number,
  hideCount: PropTypes.bool,
}

export default FilterByRange;
